import React, {Component} from 'react';
import {numericWord} from "../../../utils/formatters";
import BackEnd from "../../../backend/BackEnd";
import Size from "../../../formatters/Size";
import ActionLink from "../../../controls/ActionLink";

class MySQLStatsBox extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        showDetailsModal: false,
        dataSize: 0,
        indexSize: 0,
        rowCount: 0,
        tableCount: 0
    };
    getStatsData = new BackEnd.SystemOverview.GetMySQLStatsData(this);

    async componentDidMount() {
        let statsData = await this.getStatsData.call();

        this.setState(statsData);
    }

    render() {
        return (
            <div className={`panel box ${this.state.isLoading ? 'form-loading' : ''}`}>
                <div className="box-row">
                    <div className="box-cell p-x-2 p-y-1 bg-black text-xs-center font-size-11 font-weight-semibold">
                        <i className="fa fa-table"/>&nbsp;&nbsp;MySQL
                    </div>
                </div>
                <div className="box-row">
                    <div className="box-container text-xs-center">
                        <div className="box-row valign-middle">
                            <div className="box-cell p-y-1 b-r-1">
                                <div className="font-size-17">
                                    <strong><Size>{this.state.dataSize}</Size></strong>
                                </div>
                                <div className="font-size-11">
                                    РАЗМЕР ДАННЫХ
                                </div>
                            </div>
                            <div className="box-cell p-y-1 b-r-1">
                                <div className="font-size-17">
                                    <strong><Size>{this.state.indexSize}</Size></strong>
                                </div>
                                <div className="font-size-11">
                                    РАЗМЕР ИНДЕКСОВ
                                </div>
                            </div>
                            <div className="box-cell p-y-1">
                                {/*<div className="font-size-17">*/}
                                    {/*<strong>12</strong>*/}
                                {/*</div>*/}
                                {/*<div className="font-size-11">*/}

                                {/*</div>*/}
                            </div>
                        </div>
                        <div className="box-row valign-middle">
                            <div className="box-cell p-y-1 b-t-1 b-r-1">
                                <div className="font-size-17">
                                    <strong>{this.state.tableCount}</strong>
                                </div>
                                <div className="font-size-11">
                                    {numericWord(this.state.tableCount, 'ТАБЛИЦА', 'ТАБЛИЦЫ', 'ТАБЛИЦ')}
                                </div>
                            </div>
                            <div className="box-cell p-y-1 b-t-1 b-r-1">
                                <div className="font-size-17">
                                    <strong>{this.state.rowCount}</strong>
                                </div>
                                <div className="font-size-11">
                                    {numericWord(this.state.rowCount, 'СТРОКА', 'СТРОКИ', 'СТРОК')}
                                </div>
                            </div>
                            <ActionLink className="box-cell p-y-1 b-t-1 bg-white text-default font-size-12"
                                        onClick={() => this.setState({showDetailsModal: true})}>
                                ПОДРОБНЕЕ&nbsp;&nbsp;&gt;
                            </ActionLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MySQLStatsBox;


// WEBPACK FOOTER //
// ./src/pages/Developers/SystemOverview/MySQLStatsBox.js